import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { Button } from 'reactstrap';

import BusinessUsersList from 'components/businesses/tabs/business-users/BusinessUsersList';
import AddNewBusinessUser from 'components/businesses/tabs/business-users/AddNewBusinessUser';
import BusinessUserInvitationApi from 'apis/BusinessUserInvitation';
import BusinessUsersApi from 'apis/BusinessUsers';
import { ROUTES, insertIdtoUrl } from 'constants/Routes.js';
import { canAddUsers } from 'utils/plansHelper';
import UpgradeSubscription from 'components/subscriptionFeature/upgradeSubscription';
import DeleteModal from 'components/Modal/UserModal/DeleteModal';
import Toaster from 'components/Toaster';
import AddNewBusinessUserInvitation from './invitation/AddNewBusinessUserInvitation';

class BusinessUsers extends Component {
  constructor() {
    super();
    this.state = {
      invitedUsers: [],
      data: [],
      modalToggle: false,
      modalToggleInvitation: false,
      deleteId: '',
      isUpgradeModalVisible: false,
    };
    this.fetchUsers = this.fetchUsers.bind(this);
    this.fetchInvitedUsers = this.fetchInvitedUsers.bind(this);
    this.deleteUser = this.deleteUser.bind(this);
    this.deleteUserInvitation = this.deleteUserInvitation.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.confirmDeleteUser = this.confirmDeleteUser.bind(this);
    this.confirmDeleteInvitation = this.confirmDeleteInvitation.bind(this);
    this.modalBackdropClicked = this.modalBackdropClicked.bind(this);
    this.getDeleteUserTitle = this.getDeleteUserTitle.bind(this);
  }

  componentDidMount() {
    this.fetchUsers();
    this.fetchInvitedUsers();
  }

  componentWillReceiveProps() {
    this.fetchUsers();
    this.fetchInvitedUsers();
  }

  resendUserInvitation = userId => {
    BusinessUserInvitationApi.resend(userId)
      .then(() => {
        Toaster.getSuccessToaster('check-circle', 'User Invitation resent.');
      })
      .catch(() => {
        Toaster.getErrorToaster(
          'exclamation-triangle',
          'Error resending user invitation'
        );
      });
  };

  toggleUpgradeModal = () => {
    this.setState(({ isUpgradeModalVisible }) => ({
      isUpgradeModalVisible: !isUpgradeModalVisible,
    }));
  };

  handleAddNewUser = () => {
    const { data } = this.state;
    if (!canAddUsers(data.length)) {
      this.setState({ isUpgradeModalVisible: true });
      return;
    }

    const { history, match } = this.props;
    const { id: businessId } = match.params;

    const pushUrl = insertIdtoUrl(
      ROUTES.BUSINESS_USER_INVITATION_NEW,
      businessId
    );
    history.push(pushUrl);
  };

  confirmDeleteInvitation() {
    const { deleteId } = this.state;

    BusinessUserInvitationApi.delete(deleteId)
      .then(() => {
        Toaster.getSuccessToaster('check-circle', 'User Invitation deleted');
        this.fetchInvitedUsers();
      })
      .catch(() => {
        Toaster.getErrorToaster(
          'exclamation-triangle',
          'Error deleting user invitation'
        );
      });
    this.cancelDelete();
  }

  cancelDelete() {
    this.setState({ modalToggle: false, modalToggleInvitation: false });
  }

  modalBackdropClicked() {
    this.cancelDelete();
  }

  fetchInvitedUsers() {
    const { match } = this.props;
    const { id } = match.params;

    BusinessUserInvitationApi.getAll(id)
      .then(({ data }) => {
        this.setState({ invitedUsers: data });
      })
      .catch(e => console.log(e));
  }

  deleteUserInvitation(deleteId) {
    this.setState({ deleteId, modalToggleInvitation: true });
  }

  fetchUsers() {
    const { match } = this.props;
    const { id } = match.params;

    BusinessUsersApi.getAll(id)
      .then(({ ...data }) => {
        this.setState(data);
      })
      .catch(e => console.log(e));
  }

  confirmDeleteUser() {
    const { deleteId } = this.state;

    BusinessUsersApi.delete(deleteId)
      .then(() => {
        Toaster.getSuccessToaster('check-circle', 'User deleted');
        this.fetchUsers();
      })
      .catch(() =>
        Toaster.getErrorToaster('exclamation-triangle', 'Error deleting user')
      );
    this.cancelDelete();
  }

  deleteUser(deleteId) {
    this.setState({ deleteId, modalToggle: true });
  }

  getDeleteUserTitle() {
    const { deleteId, data } = this.state;
    if (!deleteId) {
      return;
    }

    const deleteUser = data.find((user) => {
      return user.id == deleteId;
    });
    const deleteUserFullName = `${deleteUser.user.first_name} ${deleteUser.user.last_name}`;

    return `Are you sure you want to delete the user ${deleteUserFullName}?`;
  }

  render() {
    const { match } = this.props;
    const { id: businessId } = match.params;
    const {
      data,
      invitedUsers,
      modalToggle,
      modalToggleInvitation,
      isUpgradeModalVisible,
    } = this.state;

    if (match.path === ROUTES.USER_NEW) {
      return <AddNewBusinessUser businessId={businessId} />;
    }

    if (match.path === ROUTES.BUSINESS_USER_INVITATION_NEW) {
      if (!canAddUsers(data.length))
        return <Redirect to={insertIdtoUrl(ROUTES.USERS_LIST, businessId)} />;
      return <AddNewBusinessUserInvitation businessId={businessId} />;
    }

    return (
      <div>
        <DeleteModal
          isModalVisible={modalToggle}
          onCancel={this.cancelDelete}
          onConfirm={this.confirmDeleteUser}
          modalTitle="Delete User"
          modalBodyTitle={this.getDeleteUserTitle()}
        />
        <DeleteModal
          isModalVisible={modalToggleInvitation}
          onCancel={this.cancelDelete}
          onConfirm={this.confirmDeleteInvitation}
          modalTitle="Delete User Invitation"
          modalBodyTitle="Are you sure you want to delete the User Invitation?"
        />
        <UpgradeSubscription
          isUpgradeModalVisible={isUpgradeModalVisible}
          toggleUpgradeModal={this.toggleUpgradeModal}
          type="users"
        />
        <Button
          onClick={this.handleAddNewUser}
          className="btn btn-add btn-light btn-add-new"
        >
          <FontAwesomeIcon icon="plus" /> Add User
        </Button>
        <BusinessUsersList
          users={data}
          businessId={businessId}
          deleteUser={this.deleteUser}
          deleteUserInvitation={this.deleteUserInvitation}
          invitedUsers={invitedUsers}
          resendUserInvitation={this.resendUserInvitation}
        />
      </div>
    );
  }
}

BusinessUsers.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    path: PropTypes.string,
  }).isRequired,
};

export default withRouter(BusinessUsers);



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/business-users/BusinessUsers.js